<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  agreementDisabled: { type: Boolean, default: false },
  authorizing: { type: Boolean, default: false },
  canAuthorize: { type: Boolean, default: false },
  modelValue: { type: Boolean, default: false },
});

const emit = defineEmits(['authorize', 'update:modelValue']);
const { t } = useI18n();
</script>

<template>
  <footer
    class="fixed inset-x-0 bottom-0 z-20 flex flex-wrap items-center justify-end gap-4 border-t border-lais-border bg-white px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-lais-pop sm:px-6 lg:px-10"
  >
    <label
      class="flex cursor-pointer items-center gap-2 text-sm font-medium text-lais-text"
    >
      <input
        :checked="modelValue"
        type="checkbox"
        :disabled="agreementDisabled"
        class="size-4 rounded border-lais-border text-lais-primary focus:ring-lais-primary"
        @change="emit('update:modelValue', $event.target.checked)"
      />
      {{ t('SALES.PENDING_CHARGE.AGREEMENT') }}
    </label>
    <LaisPrimaryButton
      size="lg"
      icon="i-lucide-arrow-right"
      :disabled="!canAuthorize"
      :is-loading="authorizing"
      @click="emit('authorize')"
    >
      {{ t('SALES.PENDING_CHARGE.CONFIRM') }}
    </LaisPrimaryButton>
  </footer>
</template>
